import { observer } from 'mobx-react-lite'
import { useSkillAssessmentStore } from 'src/feature/skill-assessment/store/skill-assessment.store'
import { AddExpectedRole } from '../../../dashboard/component/AddExpectedRole'
import { useEffect, useState } from 'react'
import { ExpectedRating } from '../../../dashboard/component/ExpectedRating'
import { AppBox } from 'src/component/common/analog/molecule/AppBox'
import { AppSkeleton } from 'src/component/common/analog/molecule/AppSkelton'
import { Typography } from '@mui/material'
import { useLocalizationStore } from 'src/feature/localization/store/localization.store'
import { ModalWindow } from 'src/component/common/analog/template/ModalWindow'

export type SetSkillDemandsProps = {
  levelId: string
  open: boolean
  onClose: () => void
  onDataChanged?: () => void
}

export const SetSkillDemands = observer(({ levelId, open, onClose, onDataChanged }: SetSkillDemandsProps) => {
  const { translation } = useLocalizationStore()
  const skillAssessmentStore = useSkillAssessmentStore()
  const [showAddExpectedRole, setShowAddExpectedRole] = useState(false)
  const { isLoading: isSkillcategory } = skillAssessmentStore.getGenericFieldsState('getSkillCategory')
  const { isLoading: isProfessionLoading } = skillAssessmentStore.getGenericFieldsState('getProfessionFields')
  const { isLoading: isAddSkillCategory } = skillAssessmentStore.getGenericFieldsState('addSkillCategory')
  const { isLoading: isDeleteExpectedRole } = skillAssessmentStore.getGenericFieldsState('deleteExpectedRole')
  const { isLoading: isDeleteSkillSet } = skillAssessmentStore.getGenericFieldsState('deleteSkillSet')
  const { isLoading: isAddSkillSet } = skillAssessmentStore.getGenericFieldsState('addSkillSet')
  
  const translations = translation.pages.myTeam
  const isLoading = isSkillcategory || isProfessionLoading || isAddSkillCategory || isDeleteExpectedRole || isDeleteSkillSet || isAddSkillSet

  useEffect(() => {
    getSkillcategoryData(false)
  }, [levelId])

  const getSkillcategoryData = async (notifyChange = true) => {
    skillAssessmentStore.reset()
    await skillAssessmentStore.getSkillCategory(levelId)

    setShowAddExpectedRole(!skillAssessmentStore.skillCategory)

    if (notifyChange) {
      onDataChanged?.()
    }
  }

  const handleSkillDemandsChanged = () => {
    void getSkillcategoryData(true)
  }

  return (
    <ModalWindow
      modalProps={{
        open,
        onClose,
        PaperProps: {
          sx: {
            maxWidth: { xs: '90%', sm: '600px', md: '800px', lg: '1040px' },
            borderRadius: '10px',
          },
        },
      }}
      titleProps={{
        textValue: skillAssessmentStore.skillCategory?.category_name || translations.setDemandHeader(),
      }}
      subtitleProps={{
        textValue: skillAssessmentStore.skillCategory?.category_description || translations.setDemandDesc(),
        sx: { color: 'text.secondary' },
      }}
    >
      {isLoading && <AppBox sx={{ flexDirection: 'column', gap: 20, alignItems: 'flex-start', width: '100%' }}>
        <Typography sx={{ fontSize: 16, color: 'text.secondary' }}>{translations.loadingMsg()}</Typography>
        <AppBox sx={{
          '& > div': {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
            justifyContent: 'center',
            rowGap: 20,
            columnGap: 40,
            width: '100%',
            maxWidth: 'calc(5 * 160px + 4 * 40px)',
            margin: '0 auto',
          },
          '& .MuiSkeleton-root': {
            borderRadius: '50%',
          },
        }}>
          <AppSkeleton count={10} direction="row" width={160} height={160} />
        </AppBox>
      </AppBox>}
      {!isLoading && showAddExpectedRole && !skillAssessmentStore.skillCategory && (
        <AddExpectedRole
          levelId={levelId}
          onChange={handleSkillDemandsChanged}
          disablePaper={true}
        />
      )}
      {!isLoading && !showAddExpectedRole && skillAssessmentStore.skillCategory && (
        <ExpectedRating
          levelId={levelId}
          onChange={handleSkillDemandsChanged}
          disablePaper={true}
        />
      )}
    </ModalWindow>
  )
})
